import {
  AVERAGE_GAMELIFT_STREAMS_INIT_TIME,
  AVERAGE_UE_INITIALIZATION_TIME,
} from './constants';

export const getTeleportToHubDelay = (enablePureGamecast = false) =>
  enablePureGamecast ? 9000 : 34000;

export const getLoadingIntervals = (
  loadingTimeMins: number | null = null,
  enablePureGamecast = false,
) => {
  const lastStageDelay = getTeleportToHubDelay(enablePureGamecast) / 1000;

  //1 min at least should be allocated for gamelift and ue initialization
  if (loadingTimeMins && loadingTimeMins * 60 > lastStageDelay + 60) {
    const loadingTime = loadingTimeMins * 60 - lastStageDelay;

    const sum =
      AVERAGE_GAMELIFT_STREAMS_INIT_TIME + AVERAGE_UE_INITIALIZATION_TIME;

    return {
      gameliftInitTime: Math.round(
        loadingTime * (AVERAGE_GAMELIFT_STREAMS_INIT_TIME / sum),
      ),
      ueInitTime: Math.round(
        loadingTime * (AVERAGE_UE_INITIALIZATION_TIME / sum),
      ),
      delay: lastStageDelay,
    };
  }

  return {
    gameliftInitTime: AVERAGE_GAMELIFT_STREAMS_INIT_TIME,
    ueInitTime: AVERAGE_UE_INITIALIZATION_TIME,
    delay: lastStageDelay,
  };
};
